import { useTranslation } from 'next-i18next';
import { Hotel } from '../../../core/isValidHotel';
import ImageWithFallback from '../../common/ImageWithFallback';
import Button from '../../common/Button';

type Props = {
  hotel?: Hotel;
  galleryEnabled: boolean;
  onGalleryClick: () => void;
};

const RoomPhoto = ({ hotel, galleryEnabled, onGalleryClick }: Props) => {
  const { t } = useTranslation('hotel');
  const noPhotos =
    !(hotel?.room1PhotoUrl && hotel?.room1Name) &&
    !(hotel?.room2PhotoUrl && hotel?.room2Name) &&
    !(hotel?.room3PhotoUrl && hotel?.room3Name);
  if (noPhotos) {
    return <div className="pb-10 sm:pb-0" />;
  }

  return (
    <div className="py-10">
      <p className="app-section-title">{t('room_photo.title')}</p>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-3 sm:gap-7">
        {hotel?.room1Name && hotel.room1PhotoUrl && (
          <div>
            <ImageWithFallback
              alt="first-room-photo"
              className="rounded-xl object-cover"
              src={hotel?.room1PhotoUrl || ''}
              layout="responsive"
              width={400}
              height={250}
              objectFit="cover"
              fallbackSrc="/fallback-img-3704x2304.png"
            />
            <p className="pt-2 text-regular font-bold sm:pt-4">{hotel?.room1Name}</p>
          </div>
        )}
        {hotel?.room2Name && hotel.room2PhotoUrl && (
          <div>
            <ImageWithFallback
              alt="second-room-photo"
              className="rounded-xl"
              src={hotel?.room2PhotoUrl || ''}
              layout="responsive"
              width={400}
              height={250}
              objectFit="cover"
              fallbackSrc="/fallback-img-3704x2304.png"
            />
            <p className="pt-2 text-regular font-bold sm:pt-4">{hotel.room2Name}</p>
          </div>
        )}
        {hotel?.room3Name && hotel.room3PhotoUrl && (
          <div>
            <ImageWithFallback
              alt="third-room-photo"
              className="rounded-xl"
              src={hotel?.room3PhotoUrl || ''}
              layout="responsive"
              width={400}
              height={250}
              objectFit="cover"
              fallbackSrc="/fallback-img-3704x2304.png"
            />
            <p className="pt-2 text-regular font-bold sm:pt-4">{hotel.room3Name}</p>
          </div>
        )}
      </div>
      <div className="flex justify-center pt-10 sm:pt-16">
        <Button
          className="w-full max-w-md border border-gray-200 px-0 sm:px-28"
          size="large"
          color="white"
          textColor="red"
          onClick={() => onGalleryClick()}
          disabled={!galleryEnabled}
          rounded
        >
          <p className="text-small sm:text-regular">{t('room_photo.see_photo_gallery')}</p>
        </Button>
      </div>
    </div>
  );
};

export default RoomPhoto;
